import React, { useState, ChangeEvent, FormEvent } from 'react';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { useAuth } from '../auth/auth-context';
import { useNavigate } from 'react-router-dom';

type FormData = { username: string; password: string }

const isDev = process.env.NODE_ENV === 'development'

const LoginForm: React.FC = () => {
  const { login } = useAuth()
  const [formData, setFormData] = useState<FormData>({ username: '', password: '' })
  const [isLoading, setLoading] = useState<boolean>(false)
  const [loginErr, setLoginErr] = useState<string>('')
  const navigate = useNavigate()

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    try {
        setLoading(true)
        const origin = isDev ? 'http://localhost:3050/' : 'https://api.affdash.nordpar.com/'
        const res = await fetch(origin + 'login', { 
            body: JSON.stringify(formData), 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }
        })

        if(res.status >= 400) {
            const resp = await res.text()
            setLoginErr(resp)
            return
        }

        const { token } = await res.json()
        login(token)
        setLoginErr('')
        navigate('/')
    } catch(e) {
        setLoginErr('Unable to login')
    } finally {
        setLoading(false)
    }
  }

  return (
    <div className="d-flex justify-content-center mt-3">
      <Card className="col-sm-12 col-md-6 col-lg-4">
        <Card.Body className="py-4">
          <Card.Title className="text-center">Login</Card.Title>
          <Form onSubmit={handleSubmit} action="#" method="post" noValidate name="login">
            <Form.Group className="mb-3" controlId="username">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                name="username"
                placeholder="Enter username"
                value={formData.username}
                onChange={handleInputChange}
                required
                disabled={isLoading}
                autoComplete="username"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Enter password"
                value={formData.password}
                onChange={handleInputChange}
                required
                minLength={8}
                disabled={isLoading}
                autoComplete="current-password"
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100" disabled={isLoading}>
              Login
            </Button>
            <Spinner className={`d-flex mt-3 mx-auto spinner-border ${isLoading ? '' : 'd-none'}`} />
            <div className='text-danger text-center fw-bold'>{loginErr}</div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  )
}

export default LoginForm;
